import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TransPage } from './trans';
import {NgxPaginationModule} from 'ngx-pagination';

@NgModule({
  declarations: [
    TransPage,
  ],
  imports: [
    IonicPageModule.forChild(TransPage),
    NgxPaginationModule
  ],
})
export class TransPageModule {}



// WEBPACK FOOTER //
// ./src/pages/trans/trans.module.ts